<template>
  <div class="container">
    <div @click="goback()">
      <div class="navi">
          <span class="icon-arrow-left"></span>
      </div>
    </div>
    
    <div class="title">Invoice 下载</div>
    <div class="weui-cells__title">Invoice Title（请填写英文字符）</div>

    <div class="weui-cells">
        <div class="weui-cell">
            <div class="weui-cell__bd">
                <input class="weui-input" type="text" placeholder="请输入 Invoice Title" v-model="invoices_title">
            </div>
        </div>
    </div>
    <div class="weui-cells__title">Invoice Address（请填写英文字符）</div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
          <div class="weui-cell__bd">
              <textarea class="weui-textarea" placeholder="请输入 Invoice Address" rows="3" v-model="invoices_address"> </textarea>
          </div>
      </div>
    </div>
      
    <div class="btn-box">
        <div class="btn active" @click="invoicePost()">立即下载</div>
    </div>

    <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">请稍候</p>
              </div>
          </div>
    </transition>

    <div v-show="invoiceNotice">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">创建成功</strong></div>
            <div class="weui-dialog__bd">Invoice 已创建成功，如遇下载失败，请稍等片刻再重试尝试</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="actualDownload()">立即下载</a>
            </div>
        </div>
    </div>

  </div>


</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'order-detail',
  data () {
    return {
      isSending:false,
      isSendingPricing:false,
      isLeaving:false,
      invoices_title:"",
      invoices_address:"",
      invoiceNotice:false,
      invoiceURL:"",
      pricing:{},
      orderDetail:{
        "type_id": "",
        "order_number": "",
        "member_id": "",
        "member_name": "",
        "member_phone": "",
        "member_mail": "",
        "service_date": "",
        "service_time": "",
        "deposit_amount": "",
        "offers_amount": "",
        "other_amount": "",
        "payment_amount": "",
        "order_amount": "",
        "order_status": "",
        "pay_status": "",
        "prepaid_time": "",
        "pay_time": "",
        "created": "",
        "operates": null,
        "type_name": "",
        "order_status_name": "",
        "pay_status_name": "",
        "cost_data": {
              "type_id": "",
              "floor": "",
              "duplex_floor": "",
              "carpet":"",
              "livingroom": "",
              "bedroom": "",
              "bathroom": "",
              "toiletroom": "",
              "garage": "",
              "is_return": "",
              "operates_num": ""
        },
        "details": {
              "house_type": "",
              "address": {
                  "address_name": "",
                  "address_phone": "",
                  "address_state": "",
                  "address_suburb": "",
                  "address_street": "",
                  "address_postcode": ""
              },
              "floor": "",
              "parking": "",
              "is_duplex": "",
              "duplex_floor": "",
              "labor_cost": "",
              "duplex_cost": "",
              "special_cost": "",
              "extra_cost": "",
              "extra_data": [],
              "service_start_time": "",
              "service_end_time": "",
              "service_pause_time": "",
              "service_pause_second": "",
              "service_period": "",
              "house_type_name": "",
              "floor_name": "",
              "parking_name": "",
              "attribute": {
                  "livingroom": "",
                  "bedroom": "",
                  "bathroom": "",
                  "toiletroom": "",
                  "study": "",
                  "balcony": "",
                  "garage": "",
                  "storage": "",
                  "swimming_pool": "",
                  "forecourt": "",
                  "backyard": ""
              }
        },
        "expiration_time": 0
      }
    }
  },
  methods: {
    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        this.axios.post(this.apiURL()+'/Order/orderInfo', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;

            if (localStorage.invoices_address) {
              that.invoices_address = localStorage.invoices_address;
              that.invoices_address = Vue.filter('cntpy')(that.invoices_address);

            }
            else{
              that.invoices_address = that.orderDetail.details.address.address_street + ", " + that.orderDetail.details.address.address_suburb + ", NSW " + that.orderDetail.details.address.address_postcode;
              that.invoices_address = Vue.filter('cntpy')(that.invoices_address);

            }

            if (localStorage.invoices_title) {
              that.invoices_title = localStorage.invoices_title;
              that.invoices_title = Vue.filter('cntpy')(that.invoices_title);
            }
            else{
              that.invoices_title = localStorage.member_name;
              that.invoices_title = Vue.filter('cntpy')(that.invoices_title);
            }

          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单信息获取失败，请确定网络连接正常，并刷新页面")
            that.isSending=false;
        });
      }
    },
    invoicePost(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;
        dataObject.invoices_title = this.invoices_title;
        dataObject.invoices_address = this.invoices_address;

        let RegExpression = /^[a-zA-Z\s]*$/; 
        if(!RegExpression.test(dataObject.invoices_title)){
          alert("Invoice Title 请使用纯英文字符填写（如：您的名字拼音或英文名）");
          this.isSending = false;
          return false;
        }
        else{
          this.axios.post(this.apiURL()+'/Invoices/getInvoices', qs.stringify(dataObject))
          .then(function (response) {
            if(response.data.error_code==0){
              that.isSending = false;

              let invoiceURL = response.data.data;
              that.invoiceURL = invoiceURL;
              localStorage.invoices_title = that.invoices_title;
              localStorage.invoices_address = that.invoices_address;
              that.invoiceNotice=true;
            }
            else{
              if(!that.checkLogin()){
                that.$router.push('/login');
              }
              alert("发票创建失败："+response.data.data)
              that.isSending=false;
            }
          })
          .catch(function (error) {
              console.log(error)
              alert("订单信息获取失败，请确定网络连接正常，并刷新页面")
              that.isSending=false;
          });
        }      
      }
    },
    goback(){
      this.$router.push(this.orderURL);
    },
    actualDownload(){
      window.open(this.invoiceURL,'_blank');
      this.$router.push('/clean/order-detail?id='+this.$route.query.id);
    },
  },
  computed: {
    orderURL: function (){
      let theString = this.$route.query.id;
      return '/clean/order-detail?id=' + theString;
    }
  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ {
  .weui-cell__ft{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:70%;
    font-size:0.9em;
  }

  .weui-msg__title{
    font-size:1.1em;
    margin-bottom:0;
  }

  .park-assist{
      text-align:center;
      color:#fe9567;
  }

  .prepay-img{
    width:100%;
  }
} 

</style>



// WEBPACK FOOTER //
// src/pages/clean/order-detail-invoice.vue